import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { Popover } from '@headlessui/react';
import UploadFormRimborso from "../../components/areariservata/upload_form_rimborso";
import UploadFormRimborsoKm from "../../components/areariservata/upload_form_rimborso_km";
import { createRichiestaRimborsoSpese, storicoRichiesteRimborsoSpese, deleteRichiestaRimborsoSpese } from "../../services/api_dipendenti";
import Swal from "sweetalert2";
import { PencilSquareIcon, TrashIcon, ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import Fetching from "../../components/fetching";
import XCircleIcon from '@heroicons/react/24/outline/esm/XCircleIcon';
import CheckCircleIcon from '@heroicons/react/24/outline/esm/CheckCircleIcon';
import moment from "moment";
import Empty from '../../components/empty';
import CalendarMonthSelect from '../../components/calendar_month_select';
import Footer from "../../components/footer";
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import CustomTooltipComponent from "../../components/custom_tooltip_component";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import FilePreviewModal from "../../components/preview_modal";
import { Tab } from '@headlessui/react';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import MieiVeicoliEmployee from "./miei_veicoli_employee";



function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function RimborsoSpese() {
  const { token, profile } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoading , setIsLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showFormRimborsoKm, setShowFormRimborsoKm] = useState(false);
  const [editRecordId, setEditRecordId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [hideButtonDetails, setHideButtonDetails] = useState(false);
  const [visibleRecordId, setVisibleRecordId] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null); 
  const [isEditing, setIsEditing] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [showButtonKm, setShowButtonKm] = useState(true);
  const [showButtonSpese, setShowButtonSpese] = useState(true);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [tabIndex, setTabIndex] = useState(0); 


  useEffect(() => {
    const month = selectedMonth.getMonth() + 1;
    const year = selectedMonth.getFullYear();
    fetchRecords(currentPage, '', month, year);
  }, [currentPage, selectedMonth]);
  
  const fetchRecords = async (page, status = '', month, year) => {
    setIsLoading(true);
    try {
      const [speseResponse, kmResponse] = await Promise.all([
        storicoRichiesteRimborsoSpese(token, 1, status, 'regular', 10, month, year),
        storicoRichiesteRimborsoSpese(token, 1, status, 'mileage', 10, month, year),
      ]);

      const allRecords = [...speseResponse.results, ...kmResponse.results];
      const sortedRecords = allRecords.sort((a, b) => b.id - a.id);

      const itemsPerPage = 10;
      const startIdx = (page - 1) * itemsPerPage;
      const endIdx = startIdx + itemsPerPage;

      setRecords(sortedRecords.slice(startIdx, endIdx));
      setTotalPages(Math.ceil(sortedRecords.length / itemsPerPage));
    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const toggleForm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowForm(!showForm);
      setShowButtonKm(!showButtonKm);
    }
  };

  const toggleFormRimborsoKm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowFormRimborsoKm(!showFormRimborsoKm);
      setShowButtonSpese(!showButtonSpese);
    }
  };

  const toggleDetails = (recordId) => {
    setVisibleRecordId((prevId) => (prevId === recordId ? null : recordId));
  };

  const submitFormSpese = async (formData) => {
    return await createRichiestaRimborsoSpese(token, formData, 'regular');
  };

  const submitFormKm = async (formData) => {
    return await createRichiestaRimborsoSpese(token, formData, 'mileage');
  };

  const handleDelete = async (id, type) => {
    const result = await Swal.fire({
      title: 'Sei sicuro?',
      text: "Stai eliminando la richiesta di un rimborso e l'operazione non è reversibile. Confermi l'eliminazione?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, confermo',
      cancelButtonText: 'No, annulla',
      reverseButtons: true
    });

    if (result.isConfirmed) {
      try {
        await deleteRichiestaRimborsoSpese(token, id, type);
        await Swal.fire({
          title: 'Eliminato!',
          text: 'La richiesta è stata eliminata.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        setRecords((prevRecords) =>
          prevRecords.filter((record) => record.id !== id)
        );
        fetchRecords(currentPage, '', selectedMonth.getMonth() + 1, selectedMonth.getFullYear());
      } catch (error) {
        Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione.', 'error');
      }
    }
  };

  const handleEdit = (record) => {
    if (showForm || showFormRimborsoKm) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Chiudi il form di creazione prima di modificare una richiesta.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowForm(false);
      setShowFormRimborsoKm(false);
      setShowButtonSpese(true);
      setShowButtonKm(true);

      setCurrentRecord(record);
      setIsEditing(true);
      setEditRecordId(record.id);
      setVisibleRecordId(null);
      setHideButtonDetails(true);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentRecord(null);
    setEditRecordId(null);
    setHideButtonDetails(false);
    setShowForm(false);
    setShowFormRimborsoKm(false);
    setShowButtonSpese(true);
    setShowButtonKm(true);
  };

  const handleAfterSubmitEditRecord = async (updatedRecord) => {
    setRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.id === updatedRecord.id ? updatedRecord : record
      )
    );

    await fetchRecords(
      currentPage, 
      '',
      selectedMonth.getMonth() + 1, 
      selectedMonth.getFullYear()
    );

    setEditRecordId(null);
    setHideButtonDetails(false);
    setShowForm(false);
    
  };

  const handlePreviousMonth = () => {
    setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() - 1, 1));
  };
  
  const handleNextMonth = () => {
    setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1));
  };
  
  const handleSelectClick = () => {
    setCalendarVisible(!calendarVisible);
  };

  return <div className='flex flex-col min-h-screen'>
    <div className='flex-grow pb-8'>
      <Popover as="header" className={`bg-indigo-200`}>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                <h2 className="text-center text-2xl font-semibold text-indigo-800">Rimborsi Spese</h2>
              </div>
            </div>
          </div>
        </div>
      </Popover>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-4">
        <Tab.Group selectedIndex={tabIndex} onChange={setTabIndex}>
          <Tab.List className="flex gap-2 rounded-md bg-indigo-200/60 p-1 w-fit">
            <Tab className={({ selected }) =>
              `px-4 py-2 text-sm font-semibold rounded-md focus:outline-none ${
                selected ? 'bg-white text-indigo-700 shadow'
                         : 'text-indigo-900/80 hover:bg-white/60'
              }`
            }>
              Rimborsi
            </Tab>
            <Tab className={({ selected }) =>
              `px-4 py-2 text-sm font-semibold rounded-md focus:outline-none ${
                selected ? 'bg-white text-indigo-700 shadow'
                         : 'text-indigo-900/80 hover:bg-white/60'
              }`
            }>
              I miei veicoli
            </Tab>
          </Tab.List>

          <Tab.Panels className="mt-4">
            <Tab.Panel>
      
              <section>
                <div className="container-fluid w-full pt-6">
                
                  <div className="bg-white border border-gray-300 rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                      <h3 className="text-normal font-semibold text-indigo-800 uppercase">Aggiungi Nuovo Rimborso</h3>
                      <p className="text-xs text-gray-500">Scegli il tipo di richiesta da creare</p>
                    </div>

                    {!showForm && !showFormRimborsoKm && (
                      <div className="inline-flex rounded-lg shadow-sm overflow-hidden">
                        <button
                          onClick={toggleForm}
                          className="px-4 py-2 text-sm font-semibold bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition flex items-center gap-2 focus:outline-none"
                        >
                          <CreditCardOutlinedIcon sx={{ fontSize: 18 }} />
                          Crea Rimborso Spesa
                        </button>
                        <button
                          onClick={toggleFormRimborsoKm}
                          className="px-4 py-2 text-sm font-semibold bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition border-l border-indigo-200 flex items-center gap-2 focus:outline-none"
                        >
                          <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} />
                          Crea Rimborso Chilometrico
                        </button>
                      </div>
                    )}

                    {showForm && !showFormRimborsoKm && (
                      <button
                        onClick={toggleForm}
                        className="px-4 py-2 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 hover:bg-gray-400 transition inline-flex items-center gap-2"
                      >
                        <CreditCardOutlinedIcon sx={{ fontSize: 18 }} />
                        Annulla
                      </button>
                    )}

                    {showFormRimborsoKm && !showForm && (
                      <button
                        onClick={toggleFormRimborsoKm}
                        className="px-4 py-2 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 hover:bg-gray-400 transition inline-flex items-center gap-2"
                      >
                        <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} />
                        Annulla
                      </button>
                    )}
                  </div>
                

                  {/* Container form con header soft */}
                  <div className="mx-auto pt-8">
                    {showForm && (
                      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
                        <div className="bg-indigo-50 px-4 py-3">
                          <h2 className="text-md font-semibold text-indigo-800 flex items-center gap-2 leading-none">
                            <CreditCardOutlinedIcon sx={{ fontSize: 18 }} className="shrink-0" />
                            <span>Nuovo Rimborso Spesa</span>
                          </h2>
                        </div>
                        <div className="px-4">
                          <UploadFormRimborso
                            submitForm={submitFormSpese}
                            showForm={showForm}
                            afterSubmit={() => {
                              setShowForm(false);
                              setShowFormRimborsoKm(false);
                              setShowButtonSpese(true);
                              setShowButtonKm(true);
                              fetchRecords(
                                currentPage,
                                '',
                                selectedMonth.getMonth() + 1,
                                selectedMonth.getFullYear()
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}

                    {showFormRimborsoKm && (
                      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mt-4">
                        <div className="bg-indigo-50 px-4 py-3">
                          <h2 className="text-md font-semibold text-indigo-800 flex items-center gap-2 leading-none">
                            <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 18 }} className="shrink-0" />
                            <span>Nuovo Rimborso Chilometrico</span>
                          </h2>
                        </div>
                        <div className="px-4">
                          <UploadFormRimborsoKm
                            submitFormKM={submitFormKm}
                            showForm={showForm}
                            afterSubmit={() => {
                              setShowForm(false);
                              setShowFormRimborsoKm(false);
                              setShowButtonSpese(true);
                              setShowButtonKm(true);
                              fetchRecords(
                                currentPage,
                                '',
                                selectedMonth.getMonth() + 1,
                                selectedMonth.getFullYear()
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>

              <section>
                <div className="container-fluid w-full">
                  <div className="grid grid-cols-6 gap-4 mt-2 items-center">
                    <div className="col-span-4">
                      <h3 className="text-normal uppercase font-semibold leading-6 text-indigo-800 flex items-center gap-2">
                        <SummarizeOutlinedIcon sx={{ fontSize: 18 }} className="text-indigo-700" />
                        Riepilogo
                      </h3>
                    </div>
                  </div>
                </div>
              </section>
                
              
              <div className="mt-5">
                <div className="overflow-x-auto ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
                  
                  <div className='grid grid-cols-1 w-full py-4 sticky top-0 bg-white z-20'>
                    <div
                      style={{ flex: '1 1 auto', width: 'auto' }}
                      className="pb-5 pt-2 px-4 border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
                    >
                      <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                          <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                              <button
                                  className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                  onClick={handlePreviousMonth} 
                              >
                                  <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
                              </button>
                          </div>
                          <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Mese</div>
                          <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                              <button
                                  className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                  onClick={handleNextMonth}
                              >
                                  <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                              </button>
                          </div>
                          <div
                              onClick={handleSelectClick}
                              style={{ cursor: 'pointer' }}
                              className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                          >
                              <div>
                                  {selectedMonth.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonth.getFullYear()}
                              </div>
                              {!calendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                          </div>
                          <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                              <button
                                  className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                                  onClick={handleNextMonth}
                              >
                                  <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                              </button>
                          </div>
                      </div>
                      {calendarVisible && 
                        <CalendarMonthSelect
                          selectedMonth={selectedMonth} 
                          onMonthSelect={setSelectedMonth} 
                          onCloseCalendar={handleSelectClick}
                        />
                      }
                    </div>      
                  </div>

                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className='sticky top-0 bg-white z-10 border-b border-gray-200'>
                      <tr>
                        <th className="w-[5%] text-right text-sm font-semibold text-gray-900"></th>
                        <th className="w-[20%] py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">Oggetto</th>
                        <th className="w-[10%] py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">Tipo</th>
                        <th className="w-[15%] py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">Importo</th>
                        <th className="w-[15%] py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">KM</th>
                        <th className="w-[15%] py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">Tariffa per KM</th>
                        <th className="w-[20%] px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading) && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            <Fetching />
                          </td>
                        </tr>
                      )}
                      {!isError && records.length > 0 ? (
                        records.sort((a, b) => b.id - a.id).map((record) => (
                          <React.Fragment key={record.id}>
                            <tr>
                              {/* ESPANDI / RIDUCI DETTAGLIO */}
                              <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b text-center">
                                <button
                                  onClick={() => toggleDetails(record.id)}
                                  className="text-gray-500 hover:text-gray-700"
                                >
                                  {visibleRecordId === record.id ? (
                                    <KeyboardArrowUpOutlinedIcon />
                                  ) : (
                                    <KeyboardArrowDownOutlinedIcon />
                                  )}
                                </button>
                              </td>

                              {/* OGGETTO */}
                              <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                                <div className="font-medium text-gray-900">
                                  {record.title.length > 30 ? record.title.substring(0, 30) + "..." : record.title}
                                </div>
                              </td>

                              {/* TIPO (badge) */}
                              <td className="relative py-4 pl-4 pr-3 text-sm border-b">
                                <span
                                  className={`inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2 py-1
                                    ${record.type === 'mileage'
                                      ? 'bg-orange-100 text-orange-700'
                                      : record.type === 'regular'
                                      ? 'bg-indigo-100 text-indigo-800'
                                      : 'bg-gray-100 text-gray-800'}`}
                                >
                                  {record.type === 'mileage' ? (
                                    <CustomTooltipComponent title="Rimborso KM" placement='top' arrow>
                                      <DirectionsCarFilledOutlinedIcon style={{ fontSize: '20px' }} />
                                    </CustomTooltipComponent>
                                  ) : record.type === 'regular' ? (
                                    <CustomTooltipComponent title="Rimborso spesa" placement='top' arrow>
                                      <CreditCardOutlinedIcon style={{ fontSize: '18px' }} />
                                    </CustomTooltipComponent>
                                  ) : (
                                    ''
                                  )}
                                </span>
                              </td>

                              {/* IMPORTO */}
                              <td className="relative py-4 pl-4 pr-3 text-sm border-b">
                                {(record.type === 'regular' && record.amount) ||
                                (record.type === 'mileage' && Number(record.amount) > 0) ? (
                                  <div className="font-medium text-gray-900">
                                    € {Number(record.amount).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </div>
                                ) : (
                                  <div className="text-gray-400"></div>
                                )}
                              </td>

                              {/* KM */}
                              <td className="relative py-4 pl-4 pr-3 text-sm border-b">
                                {record.type === 'mileage' && record.distance_km ? (
                                  <div className="font-medium text-gray-900">
                                    {Number(record.distance_km).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} Km
                                  </div>
                                ) : (
                                  <div className="text-gray-400"></div>
                                )}
                              </td>

                              {/* TARIFFA €/KM */}
                              <td className="relative py-4 pl-4 pr-3 text-sm border-b">
                                {record.type === 'mileage' ? (
                                  record?.rate_per_km_real != null && record?.rate_per_km_real !== '' ? (
                                    <div className="font-medium text-gray-900">
                                      {Number(record?.rate_per_km_real).toLocaleString('it-IT', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })} €/km
                                    </div>
                                  ) : (
                                    <div className="text-gray-400 justify-center flex"></div>
                                  )
                                ) : (
                                  // regular: nessun valore mostrato
                                  <div className="text-gray-400 justify-center flex">&nbsp;</div>
                                )}
                              </td>

                              {/* STATUS */}
                              <td className="relative py-4 pl-4 pr-3 text-sm border-b text-center">
                                {record.status === 'approved' ? (
                                  <CheckCircleIcon className="w-5 h-5 text-teal-500 mx-auto" />
                                ) : record.status === 'rejected' ? (
                                  <XCircleIcon className="w-5 h-5 text-red-500 mx-auto" />
                                ) : (
                                  <div>In attesa di approvazione</div>
                                )}
                              </td>
                            </tr>

                            {visibleRecordId === record.id && (
                              <>
                                <tr className="bg-indigo-50">
                                  <td colSpan="10" className="py-4 px-6 text-gray-700 text-sm">
                                    <div className="flex justify-between items-start mb-2">
                                      <h3 className="text-md uppercase font-semibold text-indigo-800">Dettagli richiesta</h3>
                                      {record.status === null && (
                                        <div className="flex space-x-2">
                                          <CustomTooltipComponent title='Modifica richiesta' placement='top' arrow>
                                            <button
                                              className="px-2 text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 text-white rounded-md"
                                              onClick={() => handleEdit(record)}
                                            >
                                              <PencilSquareIcon className="h-5 w-5" />
                                            </button>
                                          </CustomTooltipComponent>
                                          <CustomTooltipComponent title='Elimina richiesta' placement='top' arrow>
                                            <button
                                              className="px-2 text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 text-white rounded-md"
                                              onClick={() => handleDelete(record.id, record.type)}
                                            >
                                              <TrashIcon className="h-5 w-5" />
                                            </button>
                                          </CustomTooltipComponent>
                                        </div>
                                      )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                      {/* Colonna sinistra */}
                                      <div className="space-y-2">
                                        <div><strong>Oggetto:</strong> {record.title}</div>
                                        <div><strong>Data:</strong> {moment(record.date).format('DD/MM/YYYY')}</div>
                                        {record.type === 'mileage' && (
                                          <>
                                            <div><strong>Partenza:</strong> {record.departure_location}</div>
                                            <div><strong>Arrivo:</strong> {record.arrival_location}</div>

                                            <div>
                                              <strong>Distanza percorsa:</strong>{' '}
                                              {record.distance_km != null &&
                                                parseFloat(record.distance_km).toLocaleString('it-IT', {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) + ' km'}
                                            </div>
                                          </>
                                        )}

                                        {parseFloat(record.amount) > 1 && (
                                          <div>
                                            <strong>Importo:</strong>{' '}
                                            € {parseFloat(record.amount).toLocaleString('it-IT', {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                        )}

                                        {/* Descrizione */}
                                        {record.description && (
                                          <div className="pt-2">
                                            <strong>Descrizione:</strong>
                                            <div
                                              className="mt-1 text-sm text-gray-800 prose max-w-none"
                                              dangerouslySetInnerHTML={{ __html: record.description }}
                                            />
                                          </div>
                                        )}

                                        {/* Allegato */}
                                        {record.file && (
                                          <div className="pt-2">
                                            <strong>Allegati:</strong>{' '}
                                            <button
                                              type="button"
                                              onClick={() =>
                                                  setPreviewDoc({
                                                      url : record.file,
                                                      name: record.title,
                                                  })
                                              }
                                              className="text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 ml-2 text-white rounded-md"
                                            >
                                              Visualizza
                                            </button>
                                          </div>
                                        )}
                                      </div>

                                      {/* Colonna destra */}
                                      <div className="space-y-2">
                                        {record.type === 'mileage' && (
                                          <>
                                            {/* Dati veicolo dal nested */}
                                            <div><strong>Targa:</strong> {record.vehicle?.license_plate || ''}</div>
                                            <div><strong>Marca veicolo:</strong> {record.vehicle?.vehicle_brand || ''}</div>
                                            <div><strong>Modello:</strong> {record.vehicle?.vehicle_type || ''}</div>
                                            <div><strong>Alimentazione:</strong> {record.vehicle?.vehicle_motor || ''}</div>
                                          </>
                                        )}

                                        {record.status !== null && record.reviewed_on && (
                                          <div className="pt-4">
                                            <strong>Elaborata il:</strong>{' '}
                                            <time dateTime={record.reviewed_on}>
                                              {moment(record.reviewed_on).format('DD/MM/YYYY, HH:mm')}
                                            </time>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}

                            {editRecordId === record.id && currentRecord && (
                              <tr>
                                <td colSpan="10" className="pb-4">
                                  {currentRecord.type === 'mileage' ? (
                                    <UploadFormRimborsoKm

                                      afterSubmitEditRecord={handleAfterSubmitEditRecord}
                                      recordToEdit={currentRecord} 
                                      onCancelEdit={handleCancelEdit} 
                                    />
                                  ) : (
                                    <UploadFormRimborso 
                                      afterSubmitEditRecord={handleAfterSubmitEditRecord}
                                      recordToEdit={currentRecord} 
                                      onCancelEdit={handleCancelEdit} 
                                    />
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      ) :(
                        !isError && records.length === 0 && !isLoading && (
                          <tr>
                            <td colSpan="10" className='container-fluid w-full px-4 pt-4'>
                              <Empty />
                            </td>
                          </tr>
                        )
                      )}
                      
                      {/* Paginazione */}
                      <tr className='bg-gray-50 sticky bottom-0 z-10'>
                        <td colSpan="10" className="py-4">
                          <div className="flex items-center justify-between">
                            <button
                              onClick={handlePreviousPage}
                              disabled={currentPage === 1}
                              className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ml-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                currentPage === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                              }`}
                            >
                              Pagina precedente
                            </button>

                            <div className="text-sm font-semibold text-gray-800 px-2">
                              Pagina {currentPage} di {totalPages}
                            </div>

                            <button
                              onClick={handleNextPage}
                              disabled={currentPage === totalPages}
                              className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                currentPage === totalPages ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                              }`}
                            >
                              Pagina successiva
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <FilePreviewModal
                    doc={previewDoc}
                    onClose={() => setPreviewDoc(null)}
                  />
                </div>
              </div>
            </Tab.Panel>

            <Tab.Panel>
              {tabIndex === 1 && (
              <section className="mt-2">
                <div className="bg-white rounded-lg shadow ring-1 ring-gray-200">
                  <div className="flex items-center justify-between px-4 py-3 border-b">
                    <h3 className="text-base font-semibold leading-6 text-gray-900">
                    </h3>
                    <p className="text-xs text-gray-500">
                      Aggiungi, modifica o elimina i veicoli associati
                    </p>
                  </div>

                  <div className="p-4">
                    <MieiVeicoliEmployee
                      employeeId={profile?.employee?.id}
                    />
                  </div>
                </div>
              </section>
              )}
              <FilePreviewModal
                doc={previewDoc}
                onClose={() => setPreviewDoc(null)}
              />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
    <Footer />
  </div>
}